import { useNgSession } from "@sazka/ng/ng-session";
import { computed, ref } from "vue";
import { logException } from "@sazka/utils/logger/use-app-logger";
import { GwPlayerStatus } from "@/loyalty/api/models/gw-player-status";
import { fethGwPlayerStatus } from "@/loyalty/api/loyalty-api";

const { session } = useNgSession();
const playerId = computed(() => session.value?.PlayerID);

const maxGwPoints = 10;

const gwPlayerData = ref<GwPlayerStatus>({
    points: 0,
    access: { denied: true, reason: null },
    lastPointsChange: 0,
    hasBonusWheel: false,
    receivedCampaignPoints: false,
});
const hasMaxPoints = computed(() => gwPlayerData.value?.points >= maxGwPoints);

const isGwPlayerDataLoaded = ref(false);

async function loadGwPlayerData() {
    try {
        const prevPointsCache = gwPlayerData.value.points;

        gwPlayerData.value = await fethGwPlayerStatus(playerId.value);
        gwPlayerData.value.lastPointsChange = gwPlayerData.value.points - prevPointsCache;
    } catch (err) {
        logException("golden-wheel-player", err, { message: "Load player data error" });
    } finally {
        isGwPlayerDataLoaded.value = true;
    }
}

function updateGwPoints(newPoints: number) {
    gwPlayerData.value.lastPointsChange = newPoints - gwPlayerData.value.points;
    gwPlayerData.value.points = newPoints;
}

function updateGwData(newPoints: number, denied: boolean) {
    gwPlayerData.value.lastPointsChange = newPoints - gwPlayerData.value.points;
    gwPlayerData.value.points = newPoints;

    gwPlayerData.value.access.denied = denied;
}

export default {
    isGwPlayerDataLoaded,
    gwPlayerData,
    hasMaxPoints,
    maxGwPoints,

    loadGwPlayerData,
    updateGwPoints,
    updateGwData,
};
